<template>
  <div class="hero" ref="trackingEl">
    <div class="hero_top">
      <div class="mx-auto hero_box">
        <div class="logo">
          <!-- <img src="~images/home-logo-miami.svg" alt="" /> -->
          <img src="~images/2nd-logo.svg" alt="" />
        </div>
        <div class="title">
          <h2>Welcome</h2>
          <div class="sub-title">
            <h1 v-if="clientName !== 'Admin'">
              {{ clientName }}
            </h1>
          </div>
        </div>
        <p class="copy">
          Miami International Autodrome will combine the prestige of Formula 1
          with the culture of Miami to create an unparalleled racing experience.
          With incredible sightlines, exclusive access, and local chef-inspired
          menus, the Miami Grand Prix will offer an array of hospitality options
          sure to make an unforgettable weekend.
        </p>
        <div v-if="repInfo?.name !== 'Admin'" class="footer">
          <h5>{{ repInfo?.name }}</h5>
        </div>
      </div>
    </div>
    <div class="hero_bottom">
      <vimeo-player
        ref="player"
        :video-id="699054789"
        class="video"
        loop
        :options="{ responsive: true, background: true }"
      />
      <div class="video_text">
        <h2>2022 Miami Grand Prix Circuit</h2>
        <button
          type="button"
          class="btn btn-primary btn-lg px-4 gap-3"
          data-bs-toggle="modal"
          data-bs-target="#mainModal"
          @click.prevent="
            store.dispatch(`modal/setComponentName`, `modalVideo`);
            store.dispatch(`modal/setVideoId`, 699054789);
          "
        >
          Watch
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useIntersectionObserver } from "@vueuse/core";
//     store.state.purl.id,
//     store.state.purl.sessionDbId,
export default {
  name: "Hero",
  setup() {
    const store = useStore();
    const trackingEl = ref();
    // State
    const state = reactive({
      clientName: computed(() =>
        decodeURI(store.getters["purl/getClientName"])
      ),
      repInfo: computed(() => store.getters["purl/getRepInfo"]),
    });
    setTimeout(() => {
      useIntersectionObserver(
        trackingEl,
        ([{ isIntersecting }], _) => {
          if (isIntersecting) {
            store.dispatch("purl/purlPageTracking", {
              sectionId: 1,
            });
          }
        }
        // { threshold: trackingEl.id === "seatingExperiences" ? 0.3 : 0.1 }
      );
    }, 2000);

    // watch(
    //   () => state.mainPages,
    //   (mainPages) => {
    //     if (mainPages) {
    //       setTimeout(() => {
    //         var scrollEl = document?.getElementById("home")?.children;
    //         scrollEl.forEach((el) => {
    //           if (el.id)
    //             useIntersectionObserver(
    //               el,
    //               ([{ isIntersecting }], _) => {
    //                 if (isIntersecting) {
    //                   store.dispatch(`dom/setInviewSection`, el.id);
    //                 }
    //               },
    //               { threshold: el.id === "seatingExperiences" ? 0.3 : 0.1 }
    //             );
    //         });
    //         const hash = router.currentRoute.value.hash;
    //         if (hash) {
    //           const hashEl = document.querySelector(hash);
    //           if (hashEl) {
    //             store.dispatch(`dom/setInviewSection`, hash.substring(1));
    //             window.scrollTo({
    //               top: hashEl.offsetTop,
    //               behavior: "smooth",
    //             });
    //           }
    //         }
    //       }, 1500);
    //     }
    //   }
    // );

    return { ...toRefs(state), trackingEl, store };
  },
};
</script>
<style lang="scss" scoped>
.hero {
  display: flex;
  flex-direction: column;
  height: auto;
  &_top {
    position: inherit;
    z-index: 1;
    background-image: url("~images/home/bg-home.jpeg");
    background-size: cover;
    background-position: top;
    height: 617px;
    @media (max-width: 900px) {
      height: 500px;
    }
    // @media (max-width: 500px) {
    //   height: 300px;
    // }
    .hero_box {
      width: 500px;
      background: #091419;
      border-radius: 20px;
      position: relative;
      top: 133px;
      padding: 2em;
      @media (max-width: 900px) {
        width: 80vw;
        top: 50px;
      }
      // @media (max-width: 500px) {
      //   top: 50px;
      // }
      .logo {
        width: 100%;
        text-align: center;
        @media (max-width: 900px) {
          width: 200px;
          margin: 0 auto;
          img {
            width: 100%;
          }
        }
      }

      .title {
        position: relative;
        .sub-title {
          height: 50px;
          position: relative;
          top: 63px;
        }
        h2 {
          font-family: Formula1-Display-Bold;
          text-transform: uppercase;
          font-size: 91px;
          color: #ffffff;
          text-align: center;
          font-weight: 500;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          z-index: 0;
          @media (max-width: 900px) {
            font-size: 50px;
          }
        }
        h1 {
          font-family: Garland;
          font-size: 84px;
          color: #008e97;
          text-align: center;
          font-weight: 400;
          z-index: 1;
          white-space: nowrap;

          @media (max-width: 900px) {
            white-space: inherit;
            line-height: 40px;
            padding: 10px 0;
            font-size: 50px;
          }
        }
      }
      .copy {
        font-family: TitilliumWeb-Regular;
        font-size: 13px;
        color: #ffffff;
        line-height: 18px;
        font-weight: 400;
        margin-top: 100px;
      }
      .footer {
        display: flex;

        h5 {
          font-family: Formula1-Display-Bold;
          font-size: 14px;
          color: #008e97;
          font-weight: 500;
          position: relative;
          width: 100%;
          text-transform: uppercase;
          /* &::after {
            background-image: url("~images/pluses.svg");
            content: "";
            display: block;
            min-height: 0.5em;
            overflow: hidden;
            bottom: 0;
            position: absolute;
            width: 91%;
          } */
        }
      }
    }
  }
  &_bottom {
    height: 400px;
    width: 100%;
    overflow: hidden;
    position: relative;
    z-index: 0;
    @media (max-width: 900px) {
      height: 200px;
    }

    .video {
      width: 100% !important;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 0;

      &::after {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: #0000006b;
      }
      &_text {
        position: inherit;
        z-index: 1;
        text-align: center;
        top: 50%;
        transform: translateY(-50%);
        h2 {
          font-family: Formula1-Display-Bold;
          padding-block: 15px;
          font-size: 50px;
          color: #ffffff;
          text-align: center;
          text-shadow: 0 9px 4px rgba(0, 0, 0, 0.5);
          font-weight: 500;
          text-transform: uppercase;
          @media (max-width: 900px) {
            font-size: 30px;
          }
          @media (max-width: 500px) {
            font-size: 20px;
          }
        }
      }
    }
  }
}
</style>
